var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12893_383963)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66516 2.16806C2.43259 1.93008 2.05552 1.93008 1.82295 2.16806C1.59038 2.40604 1.59038 2.79187 1.82295 3.02985L13.3366 14.8111C13.5692 15.0491 13.9463 15.0491 14.1789 14.8111C14.4114 14.5731 14.4114 14.1873 14.1789 13.9493L12.7931 12.5314C13.9613 11.6253 14.877 10.3961 15.4128 8.97377C15.5296 8.66375 15.5297 8.31998 15.4131 8.0099C14.2675 4.96374 11.3804 2.80208 7.99978 2.80208C6.63679 2.80208 5.354 3.15347 4.23322 3.77256L2.66516 2.16806ZM6.21583 5.80124L7.08272 6.68827C7.35733 6.54139 7.66971 6.45833 8.00105 6.45833C9.0974 6.45833 9.98616 7.36775 9.98616 8.48958C9.98616 8.82861 9.90499 9.14825 9.76144 9.42924L10.6285 10.3164C10.9749 9.79582 11.1774 9.1669 11.1774 8.48958C11.1774 6.69465 9.75536 5.23958 8.0012 5.23958C7.33926 5.23958 6.72462 5.44677 6.21583 5.80124Z",
    fill: "#C3CBD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59516 11.6828L10.5983 13.7325C9.78452 14.0206 8.91072 14.1771 8.0012 14.1771C4.62062 14.1771 1.73347 12.0154 0.587878 8.96926C0.471261 8.65917 0.471362 8.31541 0.58816 8.00539C0.978374 6.96965 1.56998 6.03629 2.31386 5.25558L4.88045 7.88181C4.84405 8.0787 4.82501 8.28186 4.82501 8.48958C4.82501 10.2845 6.24704 11.7396 8.0012 11.7396C8.20419 11.7396 8.40275 11.7201 8.59516 11.6828Z",
    fill: "#C3CBD7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12893_383963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0209961 0.489578) rotate(0.0746971)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEye);
export default __webpack_public_path__ + "static/media/password-eye.5179861af9507e9872fe72b5f6fd62ed.svg";
export { ForwardRef as ReactComponent };